import { render, staticRenderFns } from "./PackagingList.vue?vue&type=template&id=4374dac4&scoped=true&"
import script from "./PackagingList.vue?vue&type=script&lang=js&"
export * from "./PackagingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374dac4",
  null
  
)

export default component.exports